<details-section
  title="Sections, weights and prompts"
  [showDetails]="false"
  description="{{ description }}"
>
  <scoring-weights [weights]="sectionWeights"> </scoring-weights>
  <p class="overall-heading">Overall</p>
  <div class="container" [formGroup]="form">
    <div [formGroup]="overallScorePromptGroup">
      <qai-field [label]="overallPromptLabel">
        <textarea
          qai-textarea
          autosize
          qaiPasteClean
          [maxLines]="30"
          qaiTrimLeading
          formControlName="promptText"
        ></textarea>
      </qai-field>
    </div>
  </div>
</details-section>
